//
//
//
//
//
//
//
//
//
//
//
//
//
//

import maintenanceConfig from '~/config/maintenance'

export default {
  name: 'MaintenanceBar',
  data() {
    return {
      config: maintenanceConfig,
      now: null,
      skew: 0, // server time minus client time
      timer: null
    }
  },
  computed: {
    target() {
      return Date.parse(this.config.startsAt)
    },
    remaining() {
      if (this.now === null || Number.isNaN(this.target)) return null
      return this.target - this.now
    },
    inWarningWindow() {
      return this.remaining !== null
        && this.remaining > 0
        && this.remaining <= this.config.warningMinutes * 60 * 1000
    },
    visible() {
      return this.config.alwaysShow || this.inWarningWindow
    },
    countdown() {
      if (!this.inWarningWindow) return null
      const totalSeconds = Math.ceil(this.remaining / 1000)
      const pad = (n) => String(n).padStart(2, '0')
      return `${pad(Math.floor(totalSeconds / 60))}:${pad(totalSeconds % 60)}`
    }
  },
  mounted() {
    if (Number.isNaN(this.target)) return
    this.syncServerTime()
    this.tick()
    this.timer = setInterval(this.tick, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    tick() {
      this.now = Date.now() + this.skew
    },
    async syncServerTime() {
      try {
        const res = await fetch(window.location.pathname, { method: 'HEAD', cache: 'no-store' })
        const serverDate = res.headers.get('date')
        if (serverDate) this.skew = Date.parse(serverDate) - Date.now()
      } catch (e) {}
    }
  }
}
